// extracted by mini-css-extract-plugin
export default {"container":"NavItem_container__yBryy","active":"NavItem_active__RF-Bb","icon":"NavItem_icon__YZ+7Z"};